(function (customer, $) {

    /* Initialize the Clients datatable */
    customer.InitClientsGrid = function () {
        $.ajax({
            url: "/Customer/Clients/ListClients",
            dataType: "json",
            data: {
            },
            success: function (clients) {
                $("#clientsGrid").DataTable(datatable.defaultDataTableOptions({
                    data: clients,
                    serverSide: false,
                    columns: [
                        { data: "name", name: "Name", title: "Naam", orderable: true, searchable: true },
                        { data: "ijkCustomerNumber", name: "IjkCustomerNumber", title: "Klantnummer", orderable: true, searchable: true },
                        { responsivePriority: -1, defaultContent: "", orderable: false, searchable: false }
                    ],
                    columnDefs: [
                        {
                            target: 0,
                            width: '70%',
                        },
                        {
                            target: 1,
                            width: '30%',
                        },
                        {
                            targets: 2,
                            width: '100px',
                            fixed: true,
                            render: function (data, type, full, meta) {
                                let aHrefs = ['<a href="/Customer/Clients/Delete?key=' + globalCore.urlEncode(full.key) + '" class="btn btn-datatable btn-outline-primary fas fa-trash-alt" title="Verwijderen"></a>',
                                '<a href="/Customer/Clients/Edit?key=' + globalCore.urlEncode(full.key) + '" class="btn btn-datatable btn-outline-primary fas fa-edit" title="Wijzigen"></a>'];
                                return aHrefs.join('\n');
                            }
                        }
                    ],
                    order: [[0, 'asc']]
                }));
            }
        });
    }

    /* Initialize the Profit environment datatable */
    customer.InitProfitEnvironmentGrid = function (clientKey) {
        $("#profitEnvironmentsGrid").DataTable(datatable.defaultDataTableOptions({
            ajax: {
                url: '/Customer/Clients/SearchProfitEnvironments?clientKey=' + globalCore.urlEncode(clientKey)
            },
            hideFooter: true,
            columns: [
                { data: "name", name: "Name", title: "Naam", orderable: true, searchable: false },
                { data: "afasEnvironmentNumber", name: "AfasEnvironmentNumber", title: "AFAS relatienummer ", orderable: true, searchable: false },
                { data: "hostingEnvironmentType", name: "HostingEnvironmentType", title: "Omgeving AFAS ", enum: enums.hostingEnvironmentType, orderable: true, searchable: false },
                { data: "type", name: "Type", title: "Type omgeving", enum: enums.profitEnvironmentType, orderable: true, searchable: false },
                { responsivePriority: -1, defaultContent: "", orderable: false, searchable: false }
            ],
            columnDefs: [
                {
                    targets: [0, 1],
                    width: '25%'
                },
                {
                    targets: [2, 3],
                    width: '15%'
                },
                {
                    targets: -1,
                    width: '150px',
                    fixed: true,
                    render: function (data, type, full, meta) {
                        let aHrefs = [
                            '<a href="/ProfitEnvironment/Delete?clientKey=' + globalCore.urlEncode(clientKey) + '&key=' + globalCore.urlEncode(full.key) + '" class="btn btn-datatable btn-outline-primary fas fa-trash-alt" data-bs-toggle="modal" data-bs-target="#modalcontainer" title="Verwijderen"></a>',
                            '<a href="/ProfitEnvironment/Edit?clientKey=' + globalCore.urlEncode(clientKey) + '&key=' + globalCore.urlEncode(full.key) + '" class="btn btn-datatable btn-outline-primary fas fa-edit" title="Wijzigen"></a>',
                            '<a href="/ProfitEnvironment/Validate?clientKey=' + globalCore.urlEncode(clientKey) + '&key=' + globalCore.urlEncode(full.key) + '&name=' + globalCore.urlEncode(full.name) + '" class="btn btn-datatable btn-outline-primary fas fa-check-circle" title="Controleren"></a>'];
                        return aHrefs.join('\n');
                    }
                }
            ]
        }));
    }

    /* Initialize the Client subscriptions datatable */
    customer.InitClientSubscriptionsGrid = function (clientKey, ijkCustomerNumber, allInOneBackofficeBasePath, hasAioRole) {
        $("#clientSubscriptionsGrid").DataTable(datatable.defaultDataTableOptions({
            ajax: {
                url: '/Customer/Clients/SearchClientSubscriptions?clientKey=' + globalCore.urlEncode(clientKey)
            },
            hideFooter: true,
            columns: [
                { data: "name", name: "Name", title: "Naam", orderable: true, searchable: false },
                { responsivePriority: -1, defaultContent: "", orderable: false, searchable: false }
            ],
            columnDefs: [
                {
                    targets: 0,
                    width: '80%'
                },
                {
                    targets: -1,
                    width: '150px',
                    fixed: true,
                    render: function (data, type, full, meta) {
                        switch (full?.name) {
                            case "AllInOne":
                                return hasAioRole ? '\
                                    <a data-other-backoffice href="'+ allInOneBackofficeBasePath + '/Delete?key=' + globalCore.urlEncode(full.key) + '" class="btn btn-datatable btn-outline-primary fas fa-trash-alt" title="Verwijderen"></a> \
                                    <a data-other-backoffice href="'+ allInOneBackofficeBasePath + '/CreateOrEdit?key=' + globalCore.urlEncode(full.key) + '&ijkCustomerNumber=' + globalCore.urlEncode(ijkCustomerNumber) + '" class="btn btn-datatable btn-outline-primary fas fa-cog" title="Instellingen"></a>' : '';
                        }

                        return '';
                    }
                }
            ]
        }));

        $(document).on("click", "a[data-other-backoffice]", function (event) {
            event.preventDefault();

            let backofficeWindow = window.open($(this).attr("href"), "_blank");
            let intervalId = setInterval(function () {
                if (backofficeWindow.closed) {
                    globalCore.refreshTable({ gridId: "clientSubscriptionsGrid" });
                    clearInterval(intervalId);
                }
            }, 500);
        });
    }

    /* Initialize type ahead for selecting a client  */
    customer.InitClientsTypeAhead = function () {
        $.ajax({
            url: "/Customer/Clients/ListProfitClients",
            dataType: "json",
            data: {},
            success: function (data) {
                InitBloodhound(data);
            }
        });
    }

    /* Initialize Bloodhound with search on name */
    function InitBloodhound(data) {
        const clients = new Bloodhound({
            datumTokenizer: function (client) { return Bloodhound.tokenizers.whitespace(client.name); },
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            local: data
        });

        clients.initialize();

        const clientname = $("[data-clientname]");

        // Initialize typeahead for client name, use the name as key
        clientname.typeahead({
            minLength: 1,
            hint: true,
            highlight: true
        },
            {
                name: "name",
                displayKey: "name",
                source: clients.ttAdapter(),
                templates: {
                    empty: function () {
                        $("[data-ijkcustomernumber]").html("");
                        $("[data-ijkcustomernumber-value]").val("");
                        $("[data-afasenvironmentnumber]").val("");
                        $("[data-submit]").prop("disabled", true);

                        return "<div>Geen klanten gevonden.</div>";
                    }
                }
            });

        // Get data for the selected name using the profit code
        const selectedHandler = function (eventObject, suggestionObject, suggestionDataset) {
            if(suggestionObject.ijkCustomerNumber) {
                $("[data-submit]").prop("disabled", false);
                $("[data-ijkcustomernumber]").html(suggestionObject.ijkCustomerNumber);
                $("[data-ijkcustomernumber-value]").val(suggestionObject.ijkCustomerNumber);
                const $teamsList = $("#teams-list");
                $teamsList.empty();

                if (suggestionObject.teams && suggestionObject.teams.length > 0) {
                    suggestionObject.teams.forEach(function (team) {
                        $teamsList.append('<li>' + team + '</li>');
                    });
                } else {
                    $teamsList.append('<p>Geen teams gekoppeld.</p>');
                }
            }
            else {
                $("[data-submit]").prop("disabled", true);
            }
        };
        clientname.on('typeahead:selected', selectedHandler);
    }


}(window.customer = window.customer || {}, jQuery));
